import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d1a0495"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_role_clone",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "newTargetCloneModalRef",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-100 mw-lg-50" }
const _hoisted_3 = { class: "modal-content mx-md-15" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy fs-3 text-primary" })
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body py-lg-5 px-lg-7 mh-700px scroll-y bg-light" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle table-row-bordered mb-0 fs-6 min-w-300px" }
const _hoisted_11 = { class: "fw-bold text-gray-600" }
const _hoisted_12 = {
  class: "text-muted min-w-125px",
  colspan: "2"
}
const _hoisted_13 = { class: "d-block mb-2 m-1" }
const _hoisted_14 = { class: "required" }
const _hoisted_15 = { class: "fv-plugins-message-container text-start" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = {
  class: "text-muted",
  colspan: "2"
}
const _hoisted_18 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_19 = { class: "accordion-item m-0 p-0" }
const _hoisted_20 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_4"
}
const _hoisted_21 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_4",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_1_body_4"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-check fs-2 text-primary" })
  ])
], -1))
const _hoisted_23 = {
  id: "kt_accordion_1_body_4",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_4",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_24 = {
  id: "kt_customer_view_payment_method-1",
  class: "card-body pt-0 px-5"
}
const _hoisted_25 = {
  class: "py-0",
  "data-kt-customer-payment-method": "row"
}
const _hoisted_26 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_27 = ["onClick", "href", "aria-controls"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-3 rotate-90" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z",
        fill: "black"
      })
    ])
  ])
], -1))
const _hoisted_29 = { class: "me-3" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = { class: "text-black fs-6" }
const _hoisted_32 = ["id", "data-bs-parent"]
const _hoisted_33 = { class: "w-100 py-5" }
const _hoisted_34 = { class: "table-responsive mt-3" }
const _hoisted_35 = { class: "table align-middle table-hover table-row-bordered fs-6 gy-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-35" }, "Permissions"),
    /*#__PURE__*/_createElementVNode("th", null, "Read"),
    /*#__PURE__*/_createElementVNode("th", null, "Create"),
    /*#__PURE__*/_createElementVNode("th", null, "Update"),
    /*#__PURE__*/_createElementVNode("th", null, "Delete")
  ])
], -1))
const _hoisted_37 = {
  key: 0,
  class: "form-check form-switch mb-2"
}
const _hoisted_38 = ["disabled", "id", "checked", "onClick"]
const _hoisted_39 = ["for"]
const _hoisted_40 = {
  key: 0,
  class: "form-check form-switch mb-2"
}
const _hoisted_41 = ["disabled", "id", "checked", "onClick"]
const _hoisted_42 = ["for"]
const _hoisted_43 = {
  key: 0,
  class: "form-check form-switch mb-2"
}
const _hoisted_44 = ["disabled", "id", "checked", "onClick"]
const _hoisted_45 = ["for"]
const _hoisted_46 = {
  key: 0,
  class: "form-check form-switch mb-2"
}
const _hoisted_47 = ["disabled", "id", "checked", "onClick"]
const _hoisted_48 = ["for"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1))
const _hoisted_50 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_51 = ["data-kt-indicator"]
const _hoisted_52 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_53 = { class: "svg-icon svg-icon-3 me-0" }
const _hoisted_54 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_modal_new_target_form",
          onSubmit: _ctx.submitCloneData,
          ref: "cloneLookupRef",
          class: "form",
          "validation-schema": _ctx.cloneRoleData.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.translate("common.clone")) + " - " + _toDisplayString(_ctx.roleObj?.label), 1)
              ]),
              _createElementVNode("div", {
                class: "btn btn-sm btn-icon btn-active-color-primary",
                "data-bs-dismiss": "modal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args)), ["stop"]))
              }, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("tbody", _hoisted_11, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate("common.name")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "roleName",
                          autocomplete: "off",
                          modelValue: _ctx.cloneTargetData['roleName'],
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cloneTargetData['roleName']) = $event)),
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_ErrorMessage, { name: "roleName" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("h2", _hoisted_20, [
                              _createElementVNode("button", _hoisted_21, [
                                _hoisted_22,
                                _createTextVNode(" " + _toDisplayString(_ctx.translate("common.permissions")), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionGroupsFilter, (perm, i) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["d-flex align-items-center collapsible rotate", {
                                      collapsed: _ctx.permissionGroupsCollpased[i],
                                    }]),
                                        onClick: ($event: any) => (_ctx.toggleCollapse(i)),
                                        "data-bs-toggle": "collapse",
                                        href: `#kt_1${i}`,
                                        role: "button",
                                        "aria-expanded": "false",
                                        "aria-controls": `kt_1${perm.title}`
                                      }, [
                                        _hoisted_28,
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("div", _hoisted_30, [
                                            _createElementVNode("div", _hoisted_31, _toDisplayString(perm.title), 1)
                                          ])
                                        ])
                                      ], 10, _hoisted_27)
                                    ]),
                                    _createElementVNode("div", {
                                      id: `kt_1${i}`,
                                      class: _normalizeClass(["collapse fs-6 ps-5", {
                                    show: _ctx.permissionGroupsCollpased[i],
                                  }]),
                                      "data-bs-parent": `#kt_1${i}`
                                    }, [
                                      _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("div", _hoisted_34, [
                                          _createElementVNode("table", _hoisted_35, [
                                            _hoisted_36,
                                            _createElementVNode("tbody", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(perm.childPermissions, (childPerm, j) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: j }, [
                                                  _createElementVNode("td", null, _toDisplayString(childPerm.title == "Sites"
                                                    ? "Branches"
                                                    : childPerm.title ==
                                                      "Sites Overview"
                                                    ? "Branch Overview"
                                                    : childPerm.title == "Sms"
                                                    ? "Chat"
                                                    : childPerm.title), 1),
                                                  _createElementVNode("td", null, [
                                                    (
                                                    _ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'READ'
                                                    ) != null
                                                  )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                          _createElementVNode("input", {
                                                            disabled: 
                                                      !_ctx.hasPermission(
                                                        'VYZOR:USERS:ROLES:UPDATE'
                                                      ) || _ctx.loading
                                                    ,
                                                            type: "checkbox",
                                                            class: _normalizeClass(["form-check-input", {
                                                      'form-input-unchecked':
                                                        !_ctx.checkPermission(
                                                          _ctx.getSpecificPermissionFromList(
                                                            childPerm.permissions,
                                                            'READ'
                                                          )
                                                        ),
                                                    }]),
                                                            id: `formSwitch_clone${_ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'READ'
                                                    )}`,
                                                            checked: 
                                                      _ctx.checkPermission(
                                                        _ctx.getSpecificPermissionFromList(
                                                          childPerm.permissions,
                                                          'READ'
                                                        )
                                                      )
                                                    ,
                                                            onClick: ($event: any) => (
                                                      _ctx.updatePermissionForRole(
                                                        _ctx.getSpecificPermissionFromList(
                                                          childPerm.permissions,
                                                          'READ'
                                                        ),
                                                        this.checked
                                                      )
                                                    )
                                                          }, null, 10, _hoisted_38),
                                                          _createElementVNode("label", {
                                                            class: "form-check-label",
                                                            for: `formSwitch_clone${_ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'READ'
                                                    )}`
                                                          }, null, 8, _hoisted_39)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    (
                                                    _ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'CREATE'
                                                    ) != null
                                                  )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                          _createElementVNode("input", {
                                                            disabled: 
                                                      !_ctx.hasPermission(
                                                        'VYZOR:USERS:ROLES:UPDATE'
                                                      ) || _ctx.loading
                                                    ,
                                                            type: "checkbox",
                                                            class: _normalizeClass(["form-check-input", {
                                                      'form-input-unchecked':
                                                        !_ctx.checkPermission(
                                                          _ctx.getSpecificPermissionFromList(
                                                            childPerm.permissions,
                                                            'CREATE'
                                                          )
                                                        ),
                                                    }]),
                                                            id: `formSwitch_clone${_ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'CREATE'
                                                    )}`,
                                                            checked: 
                                                      _ctx.checkPermission(
                                                        _ctx.getSpecificPermissionFromList(
                                                          childPerm.permissions,
                                                          'CREATE'
                                                        )
                                                      )
                                                    ,
                                                            onClick: ($event: any) => (
                                                      _ctx.updatePermissionForRole(
                                                        _ctx.getSpecificPermissionFromList(
                                                          childPerm.permissions,
                                                          'CREATE'
                                                        ),
                                                        this.checked
                                                      )
                                                    )
                                                          }, null, 10, _hoisted_41),
                                                          _createElementVNode("label", {
                                                            class: "form-check-label",
                                                            for: `formSwitch_clone${_ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'CREATE'
                                                    )}`
                                                          }, null, 8, _hoisted_42)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    (
                                                    _ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'UPDATE'
                                                    ) != null
                                                  )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                          _createElementVNode("input", {
                                                            disabled: 
                                                      !_ctx.hasPermission(
                                                        'VYZOR:USERS:ROLES:UPDATE'
                                                      ) || _ctx.loading
                                                    ,
                                                            type: "checkbox",
                                                            class: _normalizeClass(["form-check-input", {
                                                      'form-input-unchecked':
                                                        !_ctx.checkPermission(
                                                          _ctx.getSpecificPermissionFromList(
                                                            childPerm.permissions,
                                                            'UPDATE'
                                                          )
                                                        ),
                                                    }]),
                                                            id: `formSwitch_clone${_ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'UPDATE'
                                                    )}`,
                                                            checked: 
                                                      _ctx.checkPermission(
                                                        _ctx.getSpecificPermissionFromList(
                                                          childPerm.permissions,
                                                          'UPDATE'
                                                        )
                                                      )
                                                    ,
                                                            onClick: ($event: any) => (
                                                      _ctx.updatePermissionForRole(
                                                        _ctx.getSpecificPermissionFromList(
                                                          childPerm.permissions,
                                                          'UPDATE'
                                                        ),
                                                        this.checked
                                                      )
                                                    )
                                                          }, null, 10, _hoisted_44),
                                                          _createElementVNode("label", {
                                                            class: "form-check-label",
                                                            for: `formSwitch_clone${_ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'UPDATE'
                                                    )}`
                                                          }, null, 8, _hoisted_45)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    (
                                                    _ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'DELETE'
                                                    ) != null
                                                  )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                          _createElementVNode("input", {
                                                            disabled: 
                                                      !_ctx.hasPermission(
                                                        'VYZOR:USERS:ROLES:UPDATE'
                                                      ) || _ctx.loading
                                                    ,
                                                            type: "checkbox",
                                                            class: _normalizeClass(["form-check-input", {
                                                      'form-input-unchecked':
                                                        !_ctx.checkPermission(
                                                          _ctx.getSpecificPermissionFromList(
                                                            childPerm.permissions,
                                                            'DELETE'
                                                          )
                                                        ),
                                                    }]),
                                                            id: `formSwitch_clone${_ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'DELETE'
                                                    )}`,
                                                            checked: 
                                                      _ctx.checkPermission(
                                                        _ctx.getSpecificPermissionFromList(
                                                          childPerm.permissions,
                                                          'DELETE'
                                                        )
                                                      )
                                                    ,
                                                            onClick: ($event: any) => (
                                                      _ctx.updatePermissionForRole(
                                                        _ctx.getSpecificPermissionFromList(
                                                          childPerm.permissions,
                                                          'DELETE'
                                                        ),
                                                        this.checked
                                                      )
                                                    )
                                                          }, null, 10, _hoisted_47),
                                                          _createElementVNode("label", {
                                                            class: "form-check-label",
                                                            for: `formSwitch_clone${_ctx.getSpecificPermissionFromList(
                                                      childPerm.permissions,
                                                      'DELETE'
                                                    )}`
                                                          }, null, 8, _hoisted_48)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              }), 128))
                                            ])
                                          ])
                                        ])
                                      ])
                                    ], 10, _hoisted_32)
                                  ]),
                                  _hoisted_49
                                ], 64))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("button", {
                type: "reset",
                id: "site_clone_cancel",
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                "data-bs-dismiss": "modal",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["stop"]))
              }, _toDisplayString(_ctx.translate("common.close")), 1),
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate("common.save")), 1),
                      _createElementVNode("span", _hoisted_53, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                      _createTextVNode(_toDisplayString(_ctx.translate("common.pleaseWait")) + " ", 1),
                      _hoisted_55
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_51)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}